import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Specialite } from 'src/app/shared/models/specialite';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SpecialiteModalDetailComponent } from '../modal/specialite-modal-detail/specialite-modal-detail.component';
import { SpecialiteModalAjoutComponent } from '../modal/specialite-modal-ajout/specialite-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-specialite',
	templateUrl: './list-specialite.component.html',
	styleUrls: ['./list-specialite.component.scss']
})
export class ListSpecialiteComponent implements OnInit {
	specialites: Specialite[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	specialiteCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editSpecialiteModalRef: BsModalRef;
	addSpecialiteModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getSpecialites();
		if (this.facade.dataStorageService.isPlanificatrice()) {
			this.isAddable = true;
		}
	}

	getSpecialites(): void {
		this.isListingLoading = true;
		this.facade.specialiteService.getAllSpecialites().subscribe({
			next: (val) => {
				this.specialites = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.specialites.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.specialites = [];
			}
		});
	}

	selectSpecialite(specialite: Specialite): void {
		const link = ['/specialites', specialite.id];
		this.router.navigate(link);
	}

	importSpecialites(event: any): void {
		this.specialiteCsvFile = event.target.files[0];

		this.facade.specialiteService
			.importSpecialite(this.specialiteCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} specialites ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getSpecialites();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addSpecialiteModalRef = this.modalService.show(
			SpecialiteModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addSpecialiteModalRef.onHide.subscribe((reason: string | any) => {
			this.getSpecialites();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(specialite: Specialite) {
		const initialState = {
			specialite: specialite
		};
		this.editSpecialiteModalRef = this.modalService.show(
			SpecialiteModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editSpecialiteModalRef.onHide.subscribe((reason: string | any) => {
			this.getSpecialites();
		});
	}
}
